var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMouseEars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "253.157px",
    height: "222.966px",
    viewBox: "85.606 40.063 253.157 222.966",
    enableBackground: "new 85.606 40.063 253.157 222.966",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "disneySpendingMoney") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M333.433,119.428c-10.216,15.805-29.399,23.298-47.623,18.603c22.383,40.922,7.354,92.24-33.568,114.623 S160,260.008,137.618,219.085c-7.307-13.359-10.866-28.446-10.301-43.663c0.147-13.948,3.793-27.636,10.604-39.81 c-18.168,4.668-37.284-2.828-47.437-18.603c-11.407-24.442-2.19-53.548,21.207-66.969c27.16-15.998,55.808-12.836,69.759,10.045 c6.215,10.323,7.445,22.897,3.349,34.229c8.713-2.755,17.845-3.951,26.974-3.535c9.467-0.238,18.904,1.146,27.903,4.093 c-3.931-11.414-2.495-23.993,3.906-34.229c14.138-23.439,43.158-25.3,69.946-8.93C336.699,65.724,345.336,95.108,333.433,119.428"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouseEars);
export default __webpack_public_path__ + "static/media/mouse-ears.279f23ed.svg";
export { ForwardRef as ReactComponent };